var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogoInner = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0578 17.0109C16.2444 17.0109 17.2063 16.0493 17.2063 14.863C17.2063 13.6768 16.2444 12.7151 15.0578 12.7151C13.8711 12.7151 12.9092 13.6768 12.9092 14.863C12.9092 16.0493 13.8711 17.0109 15.0578 17.0109Z",
    fill: "#DA386C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1895 14.3511C20.1285 13.6911 19.9389 13.0615 19.6469 12.4908L20.5577 11.6282L19.9716 10.8962L19.3854 10.1643L18.3438 10.8657C17.8491 10.4562 17.276 10.136 16.6441 9.93121L16.6768 8.67864L15.7442 8.57626L14.8115 8.47388L14.5718 9.70466C13.9115 9.76565 13.2818 9.95517 12.7109 10.2471L11.848 9.33651L11.1158 9.92249L10.3836 10.5085L11.0853 11.5497C10.6756 12.0442 10.3553 12.6171 10.1505 13.2489L8.89966 13.214L8.79724 14.1464L8.69482 15.0787L9.92601 15.3183C9.98702 15.9784 10.1766 16.6079 10.4686 17.1787L9.55774 18.0413L10.1439 18.7732L10.7301 19.5052L11.7717 18.8037C12.2663 19.2133 12.8394 19.5335 13.4714 19.7382L13.4387 20.9908L14.3713 21.0932L15.304 21.1956L15.5437 19.9648C16.2039 19.9038 16.8337 19.7143 17.4046 19.4224L18.2675 20.3329L18.9997 19.747L19.7319 19.161L19.0302 18.1197C19.4399 17.6252 19.7602 17.0523 19.965 16.4206L21.218 16.4533L21.3204 15.5209L21.4228 14.5886L20.1895 14.3511ZM14.7243 17.867C13.0486 17.6819 11.8392 16.1744 12.0223 14.4993C12.2075 12.8241 13.7154 11.6151 15.3911 11.7981C17.0669 11.9832 18.2762 13.4907 18.0932 15.1658C17.908 16.8432 16.4001 18.0522 14.7243 17.867Z",
    fill: "#2694C4"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogoInner);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logoInner.e31197d99e4dc746cc6c66265ec5cf38.svg";